import {matchPath, useHistory, useLocation} from "react-router-dom";

const GO_BACK_RELATIONS: {pattern: string; goBack: string}[] = [
  {pattern: "/process-details/:id", goBack: "/search-processes"},
  {pattern: "/tasks/:id/:projectTaskName", goBack: "/project-tasks"},
  {pattern: "/contract-details/:id", goBack: "/contracts"},
  {pattern: "/company-details/:id", goBack: "/companies"},
  {
    pattern: "/email-templates/details/:idTemplate",
    goBack: "/email-templates/list",
  },
  {
    pattern: "/follow-up-templates/details/:idTemplate",
    goBack: "/follow-up-templates/list",
  },
  {
    pattern: "/fields-monitoring/details/:id",
    goBack: "/fields-monitoring",
  },
  {
    pattern: "/gente-gestao/nexperts/:id",
    goBack: "/gente-gestao/nexperts",
  },
  {
    pattern: "/responsibles-work-amount/:idResponsible",
    goBack: "/responsibles-work-amount",
  },
  {
    pattern: "/users-cp/:companyId",
    goBack: "/companies-cp",
  },
  {
    pattern: "/branches/:companyId",
    goBack: "/companies-cp",
  },
  {
    pattern: "/brokers/:companyId",
    goBack: "/companies-cp",
  },
];

type LocationStateWithGoBackTo = {
  goBackTo?: string;
};

const isInternalPath = (value: unknown): value is string => {
  return typeof value === "string" && value.startsWith("/");
};

const useRoutesGoBack = () => {
  const history = useHistory();
  const {pathname, state} = useLocation<LocationStateWithGoBackTo>();

  const goBack = (defaultTo = "/dashboards") => {
    const historyLength = (history as any)?.length;
    if (typeof historyLength === "number" && historyLength > 1) {
      history.goBack();
      return;
    }

    const goBackToFromState = (state as any)?.goBackTo;
    if (isInternalPath(goBackToFromState)) {
      history.replace(goBackToFromState);
      return;
    }

    const mapped =
      GO_BACK_RELATIONS.find((item) => {
        return matchPath(pathname, item.pattern);
      })?.goBack ?? defaultTo;
    history.replace(mapped);
  };

  return goBack;
};

export default useRoutesGoBack;
